import styled from 'styled-components'
import { giphyBlack, giphyRed } from '@giphy/js-brand'

const PrivateVideo = styled.div`
    background: ${giphyRed};
    display: flex;
    font-size: 14px;
    font-weight: bold;
    height: 40px;
    margin-bottom: 10px;
    padding: 10px;
    position: relative;
    text-align: left;
    align-items: center;
`

const PrivateDescription = styled.div`
    display: inline-block;
    margin: 0 10px;
    vertical-align: middle;
    color: ${giphyBlack};
`

const Lock = styled.div`
    font-size: 34px;
    color: ${giphyBlack};
    line-height: 46px;

    &:before {
        display: block;
        height: 36px;
    }
`

type Props = {
    description?: string
    className?: string
}

const Privacy = ({ description = 'This GIF is private and can only be seen by you.', className = '' }: Props) => (
    <PrivateVideo className={className}>
        <Lock className="ss-lock" />
        <PrivateDescription>{description}</PrivateDescription>
    </PrivateVideo>
)

export default Privacy
